import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../../modules/auth/services/authService';

const ProtectedRoute = () => {
  const isAuthenticated = authService.isAuthenticated();
  const selectedRole = localStorage.getItem('selectedRole');

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // If user is authenticated but no role is selected, redirect to role selection
  if (!selectedRole) {
    return <Navigate to="/auth/role-selection" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute; 